export const skills = [
  {
    "id": 1,
    "position1": "MERN",
    "position2": "Stack Developer",
    "experience": "More than 5 years of experience working with HTML and CSS, and 2 years of experience with JavaScript and React",
    "technologies": "MongoDB, Express, React & Node",
    "calltoaction": "Portfolio",
    "image": "profilepic.jpg"
    // "image": "mern.jpg"
  },
  {
    "id": 2,
    "position1": "UX/UI &",
    "position2": "Graphic Designer",
    "experience": "More than 7 years creating and designing web and graphic projects for companies and private clients",
    "technologies": "Creativity + Illustrator, Photoshop & Indesign",
    "calltoaction": "Portfolio",
    "image": "uxui.jpg"
  },
  {
    "id": 3,
    "position1": "STRATEGY",
    "position2": "Sales & Marketing",
    "experience": "8 years of experience building and implementing marketing, sales and communication strategies",
    "technologies": "Online & Offline Marketing Skills",
    "calltoaction": "Let's talk!",
    "image": "sales.jpg"
  }
];